import moment from 'moment/moment';
import React from 'react';
import './ProgressSteps.scss';

export function ProgressStepsContainer ({children}){
    return (
        <div className='progress-steps-container'>
            {children}
        </div>
    )
}

export function ProgressStep({step}){
    const displayDate = step.date ? moment(step.date).format('MMM D, YYYY') : '';

    return (
        <div className={'progress-step ' + (step.completed ? ' completed ' : '')}>
            <div className='progress-bar'></div>
            <div className='progress-content'>
                <span className='progress-date'>{displayDate}</span>
                {(step.labels||[]).map((label, k)=><span key={k} className='progress-label'>{label}</span>)}
                
            </div>
        </div>
    )
}